<template>
    <div id="my-wedding">
        <splash-view></splash-view>
        <lead-in-view></lead-in-view>
        <info-view></info-view>
        <attire-view></attire-view>
        <location-view></location-view>
        <weather-view></weather-view>
        <lodging-view></lodging-view>
        <registry-view></registry-view>
        <rsvp-view></rsvp-view>
    </div>
</template>

<script>
import SplashView from './views/splash.vue';
import InfoView from './views/info.vue';
import LocationView from './views/location.vue'
import LodgingView from './views/lodging.vue';
import RSVPView from './views/rsvp.vue';
import RegistryView from './views/registries.vue';
import LeadInView from './views/lead-in.vue';
import AttireView from './views/attire.vue';
import WeatherView from './views/weather';

export default {
    name: 'my-wedding',
    components: {
        WeatherView,
        LeadInView,
        RegistryView,
        'splash-view': SplashView,
        'info-view': InfoView,
        'location-view': LocationView,
        'rsvp-view': RSVPView,
        'lodging-view': LodgingView,
        'registry-view': RegistryView,
        'lead-in-view': LeadInView,
        'attire-view': AttireView
    }
};
</script>


// WEBPACK FOOTER //
// src/App.vue?c337d47a